'use client';

import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Switch } from 'src/components/PulseUI';

interface ControlledSwitchProps {
  name: string;
  label?: string;
  rules?: any;
  required?: boolean;
  value?: boolean;
  errorText?: string;
  disabled?: boolean;
}

const ControlledSwitch = ({ ...props }: ControlledSwitchProps) => {
  const { control } = useFormContext();

  if (!props) return null;

  return (
    <Controller
      name={props.name}
      control={control}
      defaultValue={props.value || false}
      render={({ field }) => {
        return (
          <label className="inline-flex items-center gap-2 cursor-pointer">
            <Switch
              checked={field.value ?? props.value ?? false}
              onChange={(e) => field.onChange(e.target.checked)}
              disabled={props.disabled || false}
            />
            {props.label && (
              <span className="text-sm text-gray-700">{props.label}</span>
            )}
          </label>
        );
      }}
    />
  );
};

export default ControlledSwitch;
